import {
  CompositeFilterFieldType,
  FilterOperatorsEnum,
  FilterSeparatorSymbolsEnum,
} from '../types';

import getFilterNestedField from './getFilterNestedField';

/**
 * Разбить составной ключ поля для фильтра на составляющие
 * @param compositeField {string}
 */
const splitCompositeFilterField = (compositeField: string): CompositeFilterFieldType => {
  const filterSeparatorSymbolIndex = compositeField.indexOf(
    FilterSeparatorSymbolsEnum.Operator,
  );

  if (filterSeparatorSymbolIndex === -1) {
    return {
      key: compositeField,
    };
  }

  const filterKey = compositeField.substring(0, filterSeparatorSymbolIndex);
  const compositeOperator = compositeField.substring(filterSeparatorSymbolIndex + 1);

  if (compositeOperator.startsWith(FilterOperatorsEnum.Min)) {
    return {
      key: filterKey,
      operator: FilterOperatorsEnum.Min,
    };
  }
  if (compositeOperator.startsWith(FilterOperatorsEnum.Max)) {
    return {
      key: filterKey,
      operator: FilterOperatorsEnum.Max,
    };
  }
  if (compositeOperator.startsWith(FilterOperatorsEnum.NestedField)) {
    return {
      key: filterKey,
      operator: FilterOperatorsEnum.NestedField,
      field: getFilterNestedField(compositeOperator),
    };
  }

  return {
    key: filterKey,
  };
};

export default splitCompositeFilterField;
